import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { session } from "../../../utilities/API/supertokenServices"
import { toast } from "react-toastify"

export const sessionApi = createAsyncThunk(
    'sessionApi', session
)

const initialState = {
    jwtToken: "",
    loader: false,
    sessionID:''
}

const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        resetJwtToken: (state) => {
            state.jwtToken = ""
            state.loader = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(sessionApi.pending, (state, action) => {
                state.loader = true
            })
            .addCase(sessionApi.fulfilled, (state, action) => {
                state.sessionID=action?.payload?.res?.sessionHandle
                state.loader = false
            })
            .addCase(sessionApi.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })
    }
})

export const { resetJwtToken } = sessionSlice.actions

export default sessionSlice.reducer